<template>
  <div class="vz-row">
    <slot />
  </div>
</template>
